<template>
  <el-dialog title="Batch Confirm Refund" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="100px">
      <el-form-item label="Status" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio label="REFUND_INFO_NOT_ENOUGH">Refund Failed due to Insufficient Info</el-radio>
          <el-radio label="REFUNDED">Refunded</el-radio>
          <el-radio label="REFUND_PENDING">Pending Refund</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        status: "REFUNDED",
      },
      dataRule: {
        status: [{ required: true, message: "please select", trigger: "submit" }],
      },
      refundOrderIdList: [],
      submitLoading: false,
    };
  },
  methods: {
    ...mapActions("finance", ["doBatchRefund"]),
    async init(idList) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      this.refundOrderIdList = idList;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.doBatchRefund({ refundIds: this.refundOrderIdList, refundStatus: this.dataForm.status })
            .then(() => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
